import TimeZoneSelectWidget from "../../components/TimeZoneSelectWidget"
import DateFormatSelectWidget from "../../components/DateFormatSelectWidget"
import DateFormatSeparatorSelectWidget from "../../components/DateFormatSeparatorSelectWidget"
import WeekendDaysSelectWidget from "../../components/WeekendDaysSelectWidget"
import FirstDayOfWeekSelectWidget from "../../components/FirstDayOfWeekSelectWidget"
import { useUserMutations } from "../hooks/use-user-mutations"
import { UserInfoUpdateData } from "../api"
import { UserViewModel } from "../api/user"
import { useAppDispatch } from "../../store"
import { SetUser } from "../store"

const UserLocaleSettings = ({ user }: { user: UserViewModel }) => {
  const { updateUserInfo } = useUserMutations()
  const dispatch = useAppDispatch()

  if (!user) return null

  const onUpdateUserInfo = async (updateData: UserInfoUpdateData) => {
    const userInfo = await updateUserInfo(user.id, updateData)
    if (userInfo) dispatch(SetUser(userInfo))
  }

  return (
    <>
      <TimeZoneSelectWidget timeZone={user.timeZone} onTimeZoneChange={onUpdateUserInfo} />
      <DateFormatSelectWidget
        dateFormat={user.dateFormat}
        dateFormatSeparator={user.dateFormatSeparator}
        onDateFormatChange={onUpdateUserInfo}
      />
      <DateFormatSeparatorSelectWidget
        dateFormatSeparator={user.dateFormatSeparator}
        onDateFormatSeparatorChange={onUpdateUserInfo}
      />
      <WeekendDaysSelectWidget weekendDays={user.weekendDays} onWeekendDaysChange={onUpdateUserInfo} />
      <FirstDayOfWeekSelectWidget firstDayOfWeek={user.firstDayOfWeek} onFirstDayOfWeekChange={onUpdateUserInfo} />
    </>
  )
}

export default UserLocaleSettings
